var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLogbookPulseVelocity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16,
    fill: "#12908D",
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.79 9L9 10.267l.281 1.432.398-.08c.53-.105.914-.153 1.167-.153.278 0 .492.062.659.167.166.104.312.267.43.512.412.869.775 2.453 1.067 4.804.29 2.336.506 5.386.646 9.152l.014.399h1.214l.12-.127c2.355-2.484 3.664-3.878 3.907-4.163l.002-.002c1.85-2.197 3.203-3.96 4.048-5.281v-.002c.839-1.324 1.425-2.465 1.745-3.416A5.917 5.917 0 0025 11.623c0-.701-.22-1.312-.67-1.801-.44-.49-.976-.759-1.596-.759-.518 0-.975.193-1.352.563l-.005.006c-.36.366-.558.809-.558 1.312 0 .676.37 1.24.972 1.692l.003.003c.258.19.431.355.536.492.107.138.12.216.12.244 0 .265-.053.556-.168.876l-.003.007-.002.008c-.138.432-.389.954-.764 1.568-.227.36-1.105 1.596-2.649 3.73l-.001.002c-.223.312-.861 1.069-1.932 2.284-.138-2.448-.248-4.091-.332-4.924v-.003c-.2-1.86-.46-3.474-.78-4.842l-.001-.003a19.021 19.021 0 00-.897-2.76L14.791 9z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.068L13.977 9c.356.85.643 1.716.861 2.6.31 1.298.563 2.837.758 4.616.092.896.219 2.79.38 5.684 1.434-1.585 2.29-2.566 2.565-2.945 1.516-2.055 2.389-3.261 2.618-3.617.38-.608.643-1.142.793-1.602.126-.344.189-.671.189-.981 0-.299-.27-.643-.81-1.034-.528-.39-.792-.826-.792-1.309 0-.367.144-.694.43-.981.3-.287.65-.431 1.051-.431.483 0 .907.2 1.275.603.367.39.551.878.551 1.464 0 .585-.092 1.148-.276 1.688-.298.872-.855 1.94-1.67 3.203-.815 1.251-2.13 2.934-3.944 5.046-.23.264-1.504 1.596-3.824 3.996h-.637c-.275-7.268-.85-11.803-1.722-13.606-.287-.586-.764-.878-1.43-.878-.287 0-.694.051-1.222.155L9 10.068z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogbookPulseVelocity);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/iconLogbookPulseVelocity.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };